import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("6J1Ga"), parcelRequire.load("g56vt"), parcelRequire.load("jwvyQ"), parcelRequire.load("iipXm"), parcelRequire.load("6e0ex"), parcelRequire.load("d4VSw"), parcelRequire.load("hCFJT"), parcelRequire.load("fFjD1")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("6J1Ga")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jwvyQ")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("iipXm")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6e0ex")} />
  <link rel="modulepreload" href={parcelRequire.resolve("d4VSw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hCFJT")} />
  <link rel="modulepreload" href={parcelRequire.resolve("fFjD1")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
